import React from 'react'

import { Table } from '../Table'
import { TableBody } from '../TableBody'
import { TableCell } from '../TableCell'
import { TableHead } from '../TableHead'
import { TableRow } from '../TableRow'

type Row = {
  key: string | number
  [key: string]: string | number | undefined
}

type Column = {
  title: string
  key: string
}

type DataTableProps = {
  className?: string
  rows: Row[]
  columns: Column[]
}

export const DataTable = ({
  className = '',
  rows,
  columns
}: DataTableProps) => (
  <Table className={className}>
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell key={column.key}>{column.title}</TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {rows.map((row) => (
        <TableRow key={row.id}>
          {columns.map((column) => (
            <TableCell key={column.key}>{row[column.key] || ''}</TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
)
